'use client';

/**
 * devlg.com - 发布需求页面（/publishRequirements）
 * 步骤条 + 合作类型选择卡片，点击卡片切换选中态
 */

import { useState } from 'react';

const IMG = '/sites/devlg.com/publishRequirements-7d950abf/images';

const TYPES = [
  {
    icon: `${IMG}/publishRequirements0201.99407cb.png`,
    title: '项目制外包',
    label: '按结果付费：',
    info: ['1.按结果付费、有保障', '2.周进度同步+3个月维护期'],
    pink: false,
  },
  {
    icon: `${IMG}/publishRequirements0202.47583e4.png`,
    title: '时间制外包',
    label: '轻量化用工：',
    info: ['1.好调动、纠纷少、响应快', '2.日报+试用期'],
    pink: false,
  },
  {
    icon: `${IMG}/e2c00aa7-87b9-4f65-ac1a-31d3f3a09294.38969b0.png`,
    title: '人才猎聘',
    label: '靠谱高效找人：',
    info: ['1.实名+信誉体系+项目展示', '2.多维度检索+人工核对'],
    pink: true,
  },
];

const PublishRequirements = () => {
  // ponytail: 原站点击「现在开始」需登录并跳转 typeProject/typeTime/typePerson 子页，此处仅保留选中交互
  const [active, setActive] = useState(0);

  return (
    <div className="bg-[#f5f7fb] overflow-hidden">
      <div className="bg-white flex flex-col justify-center mx-auto mt-5 min-h-[calc(100vh-170px)] w-[1200px] max-[1200px]:mt-0 max-[1200px]:w-full max-[1200px]:min-h-[calc(100vh-200px)]">
        <div className="mx-auto w-[680px] max-[680px]:w-full max-[680px]:pb-[30px]">
          <h1 className="text-black text-2xl font-semibold leading-6 p-2.5 text-center">
            发布需求
          </h1>

          {/* 步骤条 */}
          <div className="flex justify-between mt-[30px] px-2.5">
            <div
              className="h-10 leading-10 w-[240px] max-[680px]:w-1/3 text-center text-sm bg-no-repeat bg-[length:100%_40px] text-white"
              style={{ backgroundImage: `url(${IMG}/publishRequirements0101.3fd04a7.png)` }}
            >
              1.选择合作类型
            </div>
            <div
              className="h-10 leading-10 w-[240px] max-[680px]:w-1/3 text-center text-sm bg-no-repeat bg-[length:100%_40px] text-[#4e5969]"
              style={{ backgroundImage: `url(${IMG}/publishRequirements0102.54e1a8c.png)` }}
            >
              2.填写需求描述
            </div>
            <div
              className="h-10 leading-10 w-[240px] max-[680px]:w-1/3 text-center text-sm bg-no-repeat bg-[length:100%_40px] text-[#4e5969]"
              style={{ backgroundImage: `url(${IMG}/publishRequirements0104.8bbcba7.png)` }}
            >
              3.完成
            </div>
          </div>

          {/* 合作类型卡片 */}
          <div className="flex justify-between mx-auto mb-[30px] w-[680px] max-[560px]:flex-col max-[560px]:items-center max-[560px]:w-full">
            {TYPES.map((t, i) => (
              <div
                key={t.title}
                onClick={() => setActive(i)}
                className={`relative text-center w-[190px] max-[560px]:w-[240px] mt-[30px] max-[560px]:mt-[15px] py-8 max-[560px]:py-5 px-[15px] border-2 rounded-[10px] cursor-pointer ${
                  t.pink ? 'bg-[#fff5f5]' : 'bg-[#f7fbff]'
                } ${active === i ? 'border-[#19d485]' : 'border-[#ecf0f4]'}`}
              >
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={t.icon} alt={t.title} className="w-[50px]" />
                <div className="text-black text-lg font-semibold leading-8">{t.title}</div>
                <div className="text-[#434343] text-sm font-semibold leading-9 mt-2.5 text-left">
                  {t.label}
                </div>
                {t.info.map((line) => (
                  <div key={line} className="text-[#696969] text-sm leading-5 text-left">
                    {line}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="text-center">
            <button
              type="button"
              className="rounded-[25px] text-white text-base font-normal leading-[19px] px-[63px] py-3.5 bg-[#67c23a] border border-[#67c23a] hover:bg-[#85ce61] hover:border-[#85ce61] transition-colors duration-200"
            >
              现在开始
            </button>
            <div className="text-[#666] text-sm font-light mt-2.5">
              有问题，找平台，不甩锅！
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishRequirements;
